var ModalConfig = /** @class */ (function () {
    function ModalConfig() {
        this.body = '';
        this.closeButton = false;
        this.size = 'medium';
        this.title = '';
    }
    return ModalConfig;
}());
export { ModalConfig };
